window.addEventListener('DOMContentLoaded', () => {
	jQuery(function ($) {
		if (window.innerWidth >= 768) { 
			$('.open-search-popup').on('click', function () {
				const $wrapper = $(this).closest('.wp-block-madden-blocks-search-popup');
				const $popup = $wrapper.find('.search-popup-overlay');

				$popup.addClass('active');
				$('body').addClass('search-open');
				$popup.find('.wp-block-search__input').first().focus();
			});

		$('.search-popup-overlay').on('click', '#close-search-popup', function () {
			const $popup = $(this).closest('.search-popup-overlay');

			$popup.removeClass('active');
			$('body').removeClass('search-open');
			$popup.find('.wp-block-search__input').first().blur();
		});

		$('.search-popup-overlay').on('click', '.logo', function () {
			const $popup = $(this).closest('.search-popup-overlay');
			$popup.find('.wp-block-search__input').first().focus();
		});

		$(document).on('keydown', function (e) {
			if (e.key === 'Escape') {
				$('.search-popup-overlay.active').each(function () {
					$(this).removeClass('active');
				});
				$('body').removeClass('search-open');
			}
		});
		}
	});
});